import React from "react";
import {
  Input,
  message,
  Select,
  Button,
  Space,
  Row,
  Col,
  Modal,
  Tooltip,
  Switch,
  Dropdown,
  Image,
  Avatar,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import UserAdd from "./UserAdd";
import { CloseOutlined } from "@ant-design/icons";
import UsersStore from "../store/UsersStore";
import DepartmentStore from "../store/DepartmentStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";

import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import AssignVehicleToUser from "./AssignVehicleToUser";
import Cookies from "universal-cookie";

import Excel from "../assets/images/NewDesign/Excel.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import assignIcon from "../assets/images/NewDesign/assign.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import AssignDriverToUser from "./AssignDriverToUser";
import { hasFeature } from "../utils/componentVisibility";

const features = {
  assignDriverOption: hasFeature("assignDriverOption")
};
class CompanyUserList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.onSearch = this.onSearch.bind(this);

    this.selectDistributor = this.selectDistributor.bind(this);

    this.UsersStore = new UsersStore();
    this.DepartmentStore = new DepartmentStore();
    this.companyStore = new CompanyStore(this);
    this.cookies = new Cookies();
    this.isadmin = this.props.getUserData().isadmin;

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      distributor: "",
      distributorType: "",
      status: "",
      company_name: "",
      emailId: "",
      listUpdated: 0,
      loadList: 0,
      company_value_label: "",
      userId: "",
      openUserForm: false,

      listDataUpdate: false,
      openAssignForm: false,
      assignUserId: "",
      vehicleSelection: 0,
      showStatusConfirm: false,
      isSwitchOn: false,
      userType: "",
      userStatus: null,
      statusUserId: "",

      editData: {},
      openDeleteModal: false,
      deleteData: {},
      searchField: ""
    };
    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.UsersStore?.users?.length == 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          companyId: this.state.companyId,
          searchField: "",
          colList: result,
        };

        if (val.key == "excel") {
          this.UsersStore.exportExcel(getData);
        }
      },
    };
    this.columns = [
      {
        title: context.translate("_USER_ID_"),
        dataIndex: "userId",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_NAME_"),
        dataIndex: "name",
        width: 150,
        ellipsis: {
          showTitle: true,
        },

        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("companyuserlist") &&
                    this.onEdit(record);
                }}
              >
                {value === null ? "Admin" : value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
        dataIndex: "address",
        width: 150,
        ellipsis: {
          showTitle: true,
        },
        render: (address) => (
          <Tooltip placement="topLeft" title={address}>
            {address}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_MOBILE_NUMBER_"),
        dataIndex: "mobileno",
        width: 100,
        ellipsis: {
          showTitle: true,
        },
        render: (mobileno) => (
          <Tooltip placement="topLeft" title={mobileno}>
            {mobileno}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_EMAIL_"),
        dataIndex: "emailId",
        width: 130,
        ellipsis: {
          showTitle: true,
        },
        render: (emailId) => (
          <Tooltip placement="topLeft" title={emailId}>
            {emailId}
          </Tooltip>
        ),
      },

      {
        title: context.translate("_USER_TYPE_"),
        dataIndex: "isadmin",

        width: 140,

        ellipsis: {
          showTitle: true,
        },

        render: (mainValue, obj) => {
          let value = Number(mainValue);
          if (value === 1 || value === 3) {
            return (
              // <Tag
              //   style={{ width: 80, textAlign: "center" }}
              //   color={config.adminColor}
              // >
              <div className="list-status-admin">{this.context.translate("_ADMIN_")}</div>
              // </Tag>
            );
          } else if (value === 5) {
            if (Number(obj.userType) === 5) {
              return (
                // <Tag
                //   style={{ width: 80, textAlign: "center" }}
                //   color={config.salesPersonColor}
                // >
                <div className="list-status-salesperson">{this.context.translate("_SALES_PERSON_")}</div>
                // </Tag>
              );
            }
            if (Number(obj.userType) === 6) {
              return (
                // <Tag
                //   style={{ textAlign: "center" }}
                //   color={config.salesPersonColor}
                // >
                <div className="list-status-coordinator">
                  {this.context.translate("_TRANSPORT_CORDINATOR_")}
                </div>
                // </Tag>
              );
            } else {
              return (
                // <Tag
                //   style={{ width: 80, textAlign: "center" }}
                //   color={config.salesPersonColor}
                // >
                <div className="list-status-salesperson">{this.context.translate("_SALES_PERSON_")}</div>
                // </Tag>
              );
            }
          } else if (value === 2) {
            return (
              // <Tag
              //   style={{ width: 80, textAlign: "center" }}
              //   color={config.driverColor}
              // >
              <div className="list-status-driver">{this.context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_")}</div>
              // </Tag>
            );
          } else {
            return (
              // <Tag
              //   style={{ width: 80, textAlign: "center" }}
              //   color={config.userColor}
              // >
              <div className="list-status-user"> {this.context.translate("_FLEET_MANAGEUSER_USER_TAB_")}</div>
              // </Tag>
            );
          }
        },
      },
      {
        title: context.translate("_DEPARTMENT_"),
        dataIndex: "departmentName",
        width: 100,
        ellipsis: {
          showTitle: true,
        },
        render: (departmentName) => (
          <Tooltip placement="topLeft" title={departmentName}>
            {departmentName}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_FLEET_COMPANY_USERDETAIL_USERNAME_"),
        dataIndex: "username",
        width: 100,
        ellipsis: {
          showTitle: true,
        },
        render: (username) => (
          <Tooltip placement="topLeft" title={username}>
            {username}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_STATUS_"),
        dataIndex: "status",
        width: 80,
        ellipsis: {
          showTitle: true,
        },

        render: (value) => {
          if (value == 1) {
            return (
              // <Tag
              //   style={{ width: 55, textAlign: "center" }}
              //   color={config.activeColor}
              // >
              <div className="list-status-active"> Active</div>

              // </Tag>
            );
          } else if (value == 0) {
            return (
              // <Tag
              //   style={{
              //     color: "white",
              //     backgroundColor: config.inActiveColor,
              //     width: 55,
              //     textAlign: "center",
              //   }}
              // >
              <div className="list-status-inactive"> Inactive</div>

              // </Tag>
            );
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        width: 90,
        align: "center",
        ellipsis: {
          showTitle: true,
        },

        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={
                    record.status == "1"
                      ? context.translate("_ACTIVE_")
                      : context.translate(
                        "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                      )
                  }
                  placement="top"
                  color={
                    record.status == "1"
                      ? config.activeColor
                      : config.inActiveColor
                  }
                >
                  {this.props.canDelete("companyuserlist") && (
                    <Switch
                      className="switch-btn"
                      size="small"
                      checked={Number(record.status)}
                      onChange={async (val) => {
                        this.setState({ statusUserId: record.userId });
                        this.setState({ isActive: val });
                        this.setState({ showStatusConfirm: true }); // open modal
                      }}
                    />
                  )}
                </Tooltip>

                {(this.props.getUserData().isadmin === -1 ||
                  (this.props.getUserData().isadmin !== -1 &&
                    record.isadmin !== 1 &&
                    record.isadmin !== 3 &&
                    this.props.canDelete("companyuserlist"))) && (
                    <Tooltip
                      title={this.context.translate(
                        "_FLEET_USER_USERLIST_DELETE_"
                      )}
                      placement="bottom"
                    >
                      <Image
                        src={require("../assets/images/NewDesign/Delete.png")}
                        style={{ cursor: "pointer", width: "15px" }}
                        onClick={() =>
                          this.setState({
                            openDeleteModal: true,
                            deleteData: record,
                          })
                        }
                      ></Image>
                    </Tooltip>
                  )}
                {(record.isadmin == 0 && features.assignDriverOption) &&
                  (
                    <Tooltip
                      title={this.context.translate(
                        "_ASSIGN_DRIVER_"
                      )}
                      placement="bottom"
                    >
                      <Image
                        src={require("../assets/images/NewDesign/assignDriver.jpg")}
                        style={{ cursor: "pointer", width: "25px" }}
                        onClick={() =>
                          this.setState({
                            openAssignDriverForm: true,
                            assignUserId: this.state.editData?.userId,
                            vehicleSelection: this.state.editData?.vehicleSelection,
                          })
                        }
                      ></Image>
                    </Tooltip>

                  )}
                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                >
                  <Image
                    style={{ cursor: "pointer" }}
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>




              </Space>
            </>
          );
        },
      },
    ];

    // if (this.props.getUserData().isadmin == 0) {
    //   this.columns = this.columns.filter((item) => item.dataIndex !== "Action");
    // }

    if (![-1, 1, 3].includes(this.props.getUserData().isadmin)) {
      this.columns = this.columns.filter((item) => item.dataIndex !== "Action");
    }

    this.actionColumn = {
      items: [
        this.props.canUpdate("companyuserlist") && {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() =>
                this.setState({
                  openAssignForm: true,
                  assignUserId: this.state.editData?.userId,
                  vehicleSelection: this.state.editData?.vehicleSelection,
                })
              }
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={assignIcon}
              ></Avatar>
              {context.translate("_ASSIGN_")}
            </div>
          ),
          key: "assign",
        },

      ],
    };
  }
  onEdit = async (record) => {
    // console.log(record.companyId)
    console.log(record);
    // await this.context.setBeforeEditState(record.companyId);
    await this.context.viewStateStore.setUserAddStates({
      companyId: record.companyId,
    });
    // await this.props.navigate("/useradd/" + record.userId);
    await this.setState({ openUserForm: true });
    await this.setState({ userId: record.userId });
  };

  async onDelete(record) {
    const response = await this.UsersStore.deleteRecord({
      userId: record.userId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  // sendEmail = async (record) => {
  //   this.setState({ loading: true });
  //   console.log(record, "sfsdfdgdfgdfgfhgh");
  //   const resp = await this.UsersStore.sendEmail({
  //     emailId: record.emailId,
  //     username: record.username,
  //     password: record.password,
  //   });
  //   // console.log(response);

  //   if (resp.data.success === "S") {
  //     message.success(resp.data.message);
  //   } else if (resp.data.success === "F0") {
  //     // resp.data.errors.map((value) => {
  //     message.error(resp.data.message);
  //     // });
  //   }

  //   this.setState({ loading: false });
  // };
  loadSessionState = (sessionKey, stateKey) => {
    const data = sessionStorage?.getItem(sessionKey);

    if (data) {
      const parsed = JSON.parse(data);
      this.setState({
        [stateKey]: parsed[stateKey],
      });

      return parsed[stateKey];
    }

    return null;
  };

  async componentDidMount() {

    this.loadSessionState('userStatus_session', 'userStatus');
    this.loadSessionState('userType_session', 'userType');
    this.loadSessionState('searchField_session', 'searchField');

    const company_value_label = this.loadSessionState(
      'company_value_label_session',
      'company_value_label'
    );

    if (company_value_label) {
      this.setState(
        {
          companyId: company_value_label.value,
        },
        () => {
          this.handleSearch();
        }
      );
    }




    console.log(this.props.getUserData());
    // const data=JSON.parse(base64_decode(this.cookies.get("data")))
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });

      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
    // await this.handleSearch();
  }
  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.openUserForm &&
      prevState.openUserForm !== this.state.openUserForm
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.userAddStatesObj.companyId;

      await this.UsersStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: beforeEditCompanyId,
        isadmin: this.props.getUserData().isadmin,
        // userId:
        //   this.props.getUserData().isadmin == 0
        //     ? this.props.getUserData().userId
        //     : 0,
        ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
          userId: this.props.getUserData().userId,
        }),
      });

      const singleData = await this.companyStore.getCompanyDataById(
        this.context.viewStateStore.userAddStatesObj.companyId
      );
      // this.setState({companyId:this.state.})
      await this.setState({ listUpdated: 1 }); //need to reload data
      await this.setState({
        company_value_label: singleData,
        companyId: beforeEditCompanyId,
      });
      await this.setState({ listDataUpdate: false });
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async selectDistributor(value) {
    //  console.log("value",value)
    await this.setState({ distributor: value });
    await this.handleSearch();
  }

  async handleChange({ comp, userId }) {
    // console.log(comp);
    if (comp) {
      await this.setState({
        currentPage: 1,
        companyId: comp.value,
        pageSize: 50,
        // isadmin:this.isadmin
      });
      const singleData = await this.companyStore.getCompanyDataById(
        comp.value,
        this.isadmin
      );
      console.log(singleData);
      await this.setState({ company_value_label: singleData });
      console.log(this.state.company_value_label);

      // await this.UsersStore.beforeEditCompanyId(comp.value)
      await this.handleSearch();
      await this.setState({ loadList: 1 });
    }
    // if (userId) {
    //   const data = await this.UsersStore.getDeviceGroups({
    //     companyId: this.state.companyId,
    //   });
    //   console.log(data);
    //   const data1 = await this.UsersStore.getVehiclesData({
    //     companyId: this.state.companyId,
    //     userId: userId,
    //   });
    //   console.log(data1);

    //   // console.log(this.UsersStore?.users);
    // }
    await this.setState({ loadList: 1, pageSize: 50 });
  }



  async handleSearch() {
    this.setState({ loading: true });
    await this.UsersStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      searchField: this.state.searchField,
      userStatus: this.state.userStatus,
      userType: this.state.userType,
      isadmin: this.props.getUserData().isadmin,
      ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
        userId: this.props.getUserData().userId,
      }),
    });
    // console.log(this.props.getUserData().isadmin);
    await this.setState({ listUpdated: 1 }); //need to reload data
    await this.setState({ loading: false });
  }

  async onSearch() {
    this.setState({ loading: true });
    await this.UsersStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      searchField: this.state.searchField,
      userStatus: this.state.userStatus,
      userType: this.state.userType,
      ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
        userId: this.props.getUserData().userId,
      }),

    });

    await this.setState({ listUpdated: 1 }); //need to reload data
    await this.setState({ loading: false });
  }

  searchInput = async (e) => {
    const value = e.target.value;

    // await this.setState({searchField:value})
    if (value.length > 3) {
      await this.UsersStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
        ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
          userId: this.props.getUserData().userId,
        }),
      });

      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.UsersStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        // searchField: value,
        companyId: this.state.companyId,
        ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
          userId: this.props.getUserData().userId,
        }),
      });
      await this.setState({ currentPage: 1 });
    }
  };

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openUserForm: false });

      //  await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["username"]);
      });
    } else {
      message.error(resp.data.message);
    }
  };

  assignresponseMsg = async (response) => {
    if (response.data.success === "S") {
      message.success(response.data.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openAssignForm: false });
      await this.handleSearch();
    } else {
      await message.error(response.data.message);
      await this.setState({ loading: false });
    }
  };

  closeModal = () => {
    this.setState({ openUserForm: false, userId: "" });
  };

  closeModalAssign = () => {
    this.setState({ openAssignForm: false });
  };
  closeModalAssignDriver = () => {
    this.setState({ openAssignDriverForm: false });
  }
  confirmStatus = async (status) => {
    const data = {};

    data.userId = this.state.statusUserId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.UsersStore.updateStatus(data);
    await this.setState({ showStatusConfirm: false });

    await this.handleSearch();
  };
  cancelConfirm = async (response) => {
    this.setState({ isSwitchOn: false });
    this.setState({ showStatusConfirm: false });
  };

  handleExportClick = (val) => {
    let result = [];
    if (true) {
      this.columns.map((obj) => result.push(obj.dataIndex));
      //  console.log(result.toString())

      var getData = {
        companyId: this.state.companyId,

        searchField: "",
        colList: result,
      };
      console.log(getData);
      if (val) {
        // console.log("afd")
        this.UsersStore.exportExcel(getData);
      }
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.UsersStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        ...(![-1, 1, 3].includes(this.props.getUserData().isadmin) && {
          userId: this.props.getUserData().userId,
        }),

      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  handleClear = async () => {
    await this.setState({
      company_value_label: null,
      companyId: "",
      cName: "",
    });
    sessionStorage.clear();

  };
  render() {
    //console.log('in render1')
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  ref={this.companyRef}
                  onChange={(comp) => {
                    this.handleChange({ comp })
                    sessionStorage.setItem('company_value_label_session', JSON.stringify({
                      company_value_label: comp
                    }));
                  }}
                  //  onChange={(val) => {
                  //     this.handleChange({val});
                  //     //console.log(val);
                  //      sessionStorage.setItem('companyVal_Lab_session', JSON.stringify({
                  //           companyVal_Lab : val
                  //       }));
                  //   }}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  allowClear={true}
                  onClear={this.handleClear}
                  style={{ width: 165 }}
                  fromAccountList={1}
                />
                {this.props.getUserData().isadmin != 0 && (
                  <Select
                    className="searchInput"
                    style={{
                      width: 150,
                    }}
                    value={
                      this.state.userStatus !== null
                        ? this.state.userStatus
                        : null
                    }
                    onSelect={async (val) => {
                      console.log("vallllll", val);
                      await this.setState({ userStatus: val });
                      await this.onSearch();

                      sessionStorage.setItem('userStatus_session', JSON.stringify({
                        userStatus: val
                      }));

                    }}
                    placeholder={this.context.translate(
                      "_FLEET_USER_USERLIST_STATUS_"
                    )}
                    options={[
                      {
                        value: -1,
                        // label: "All",
                        label:this.context.translate("_ALL_")
                      },
                      {
                        value: 1,
                        // label: "Active",
                        label:this.context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_")
                      },
                      {
                        value: 0,
                        // label: "Inactive",
                        label:this.context.translate("_FLEET_USER_USERLIST_STATUS_INACTIVE_")
                      },
                    ]}
                  />
                )}
                {this.props.getUserData().isadmin != 0 && (
                  <Select
                    className="searchInput"
                    style={{
                      width: 150,
                    }}
                    value={this.state.userType ? this.state.userType : null}
                    onSelect={async (val) => {
                      console.log(val);
                      await this.setState({ userType: val });
                      await this.onSearch();

                      sessionStorage.setItem('userType_session', JSON.stringify({
                        userType: val
                      }));

                    }}
                    placeholder={this.context.translate("_USER_TYPE_")}
                    options={[
                      {
                        value: 1,
                        label: this.context.translate("_ADMIN_"),
                      },

                      {
                        value: 2,
                        label: this.context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
                      },
                      {
                        value: 5,
                        label: this.context.translate("_SALES_PERSON_"),
                      },
                      {
                        value: 6,
                        label: this.context.translate("_TRANSPORT_CORDINATOR_"),
                      },
                      {
                        value: 7,
                        label: this.context.translate("_FLEET_MANAGEUSER_USER_TAB_"),
                      },
                    ]}
                  />
                )}
                {this.props.getUserData().isadmin != 0 && (
                  <Input
                    // placeholder="Search By Name,Mobile No,Email"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_NAME_MOBILE_EMAIL_"
                    )}
                    value={this.state.searchField}
                    style={{ width: 400, borderRadius: "25px" }}
                    onChange={async (e) => {
                      await this.setState({ searchField: e.target.value });

                      sessionStorage.setItem('searchField_session', JSON.stringify({
                        searchField: e.target.value
                      }));

                      await this.searchInput(e);



                    }}
                  />
                )}
                {/* {this.props.getUserData().isadmin != 0 && (
                  <Button
                    icon={<SearchOutlined />}
                    type="primary"
                    onClick={async () => {
                      // this.handleSearch();
                      await this.UsersStore.loadData({
                        offset: 0,
                        limit: this.state.pageSize,
                        searchField: this.state.searchField,
                        companyId: this.state.companyId,
                      });
                      // await this.onSearch()
                      await this.setState({ loadData: 1 });
                    }}
                  />
                )} */}
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({
                        searchField: "",
                        userStatus: "",
                        userType: "",
                      });
                    }}
                  ></Image>
                </Tooltip>

                <Tooltip
                  title={this.context.translate("_DOWNLOAD_")}
                  placement="bottom"
                >
                  <span>
                    <Button
                      className="downloadExcelButton"
                      disabled={
                        this.UsersStore?.users?.length > 0 ? false : true
                      }
                      onClick={(val) => {
                        let result = [];
                        if (true) {
                          this.columns.map((obj) => result.push(obj.dataIndex));

                          var getData = {
                            companyId: this.state.companyId,
                            searchField: "",
                            colList: result,
                          };
                          if (val) {
                            this.UsersStore.exportExcel(getData);
                          }
                        }
                      }}
                    >
                      <Image
                        style={{
                          height: 18,
                          width: "auto",
                        }}
                        src={downloadIcon}
                      />
                    </Button>
                  </span>
                </Tooltip>
                {/* Number(this.props.getUserData().isadmin) != 0 && */}

                {this.props.canCreate("companyuserlist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() => {
                      this.setState({ openUserForm: true, userId: "" });
                    }}
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          {this.state.openUserForm && (
            // <Modal
            //   bodyStyle={{ height: "645px" }}
            //   className="formShowModal"
            //   // title="User Details"
            //   title={this.context.translate("_FLEET_COMPANY_USERDETAIL_TITLE_")}
            //   centered
            //   open={this.state.openUserForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openUserForm: false, userId: "" });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openUserForm}
              footer={false}
              placement={

                this.context.locale.language === "arabic" ? "left" : "right"

              }
              title={
                <div className="formTitle">
                  {this.context.translate("_FLEET_COMPANY_USERDETAIL_TITLE_")}
                  <p className="formDescription">
                    {this.context.translate("_USER_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openUserForm: false })}
              onCancel={() =>
                this.setState({ openUserForm: false, userId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <UserAdd
                  userId={this.state.userId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          {this.state.openAssignForm && (
            // <Modal
            //   bodyStyle={{ height: "645px" }}
            //   className="formShowModal" //
            //   // title="Assign Vehicles"
            //   title={this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
            //   centered
            //   visible={this.state.openAssignForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openAssignForm: false });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openAssignForm}
              placement={

                this.context.locale.language === "arabic" ? "left" : "right"

              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                  <p className="formDescription">
                    {this.context.translate("_ASSIGN_FORM_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openAssignForm: false })}
              onCancel={() =>
                this.setState({ openAssignForm: false, userId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <AssignVehicleToUser
                  companyId={this.state.companyId}
                  userId={this.state.assignUserId}
                  response={this.assignresponseMsg}
                  vehicleSelection={Number(this.state.vehicleSelection)}
                  closeModalAssign={this.closeModalAssign}
                // vehicleSelection={Number(2)}
                />
              </div>
            </Drawer>
          )}

          {this.state.showStatusConfirm && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>{this.context.translate("_CONFIRM_")}</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showStatusConfirm: false })}
                  />
                </div>
              }
              className="update-statusModal"
              description="Are you sure to change this status?"
              centered
              open={this.state.showStatusConfirm}
              footer={null}
              // onOk={this.confirmStatus}
              width={400}
              closable={false}
            >
              <div className="confirmStatusText">
                {this.state.isActive === true ? (
                  <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
                ) : (
                  <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
                )}
              </div>
              <div className="confirmStatusButtons">
                <Button
                  onClick={() => this.setState({ showStatusConfirm: false })}
                  className="confirmStatusCancelButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="confirmStatusOkButton"
                  onClick={() => this.confirmStatus()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                  )}
                </Button>
              </div>
            </Modal>
          )}

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.UsersStore?.total}
            columns={this.columns}
            dataSource={this.UsersStore?.users}
            loading={this.UsersStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openAssignDriverForm && (

          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openAssignDriverForm}
            placement={

              this.context.locale.language === "arabic" ? "left" : "right"

            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                <p className="formDescription">
                  {this.context.translate("_ASSIGN_FORM_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openAssignDriverForm: false })}
            onCancel={() =>
              this.setState({ openAssignDriverForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <AssignDriverToUser
                companyId={this.state.companyId}
                userId={this.state.assignDriverUserId}
                response={this.assignresponseMsg}
                closeModalAssignDriver={this.closeModalAssignDriver}
              />
            </div>
          </Drawer>
        )}
      </>
    );
  }
}
CompanyUserList.contextType = StoreContext;
export default observer(withRouter(CompanyUserList));
